import { render } from "./ConnectWallet.vue?vue&type=template&id=36b7f02f&scoped=true"
import script from "./ConnectWallet.vue?vue&type=script&lang=js"
export * from "./ConnectWallet.vue?vue&type=script&lang=js"

import "./ConnectWallet.vue?vue&type=style&index=0&id=36b7f02f&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b7f02f"]])

export default __exports__